import { render, staticRenderFns } from "./viewVIDEO.vue?vue&type=template&id=44f2811e&scoped=true"
import script from "./viewVIDEO.vue?vue&type=script&lang=js"
export * from "./viewVIDEO.vue?vue&type=script&lang=js"
import style0 from "./viewVIDEO.vue?vue&type=style&index=0&id=44f2811e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f2811e",
  null
  
)

export default component.exports